<template>
  <div class="flex items-center gap-2 px-6 py-4">
    <span class="text-base capitalize text-primary">{{ entityPlural }}</span>
    <div
      class="default-badge font-inter w-fit select-none rounded-full bg-main-tertiary/10 px-3 py-1 text-center text-main-primary"
    >
      <span class="block text-xs lowercase">{{ count }} {{ entityPlural }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableCountTitle',

  props: {
    entity: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },

  computed: {
    entityPlural() {
      return this.entity.charAt(this.entity.length - 1) === 's'
        ? this.entity
        : `${this.entity}s`
    },
  },
}
</script>
